import { stringify } from 'query-string';

import { DepartmentTemplate, DepartmentTemplateField, FetchCrudData } from '../models';
import { Network } from '../utils';

const fields = [DepartmentTemplateField.NAME].join(',');

export const getDepartmentTemplates = async (filters: FetchCrudData): Promise<DepartmentTemplate[]> => {
  return Network.get(
    `departmentTemplates?${stringify({
      ...filters,
      s: JSON.stringify(filters.s),
      fields,
    })}`,
  );
};
export const addDepartmentTemplate = async (name: string) => Network.post('departmentTemplates', { name });
export const editDepartmentTemplate = async (department: DepartmentTemplate) =>
  Network.patch(`departmentTemplates/${department.id}`, department);
export const deleteDepartmentTemplate = async (id: string) => Network.delete(`departmentTemplates/${id}`);
